export default "__VITE_ASSET__Bj3kt7Ty__"